import { IsOptional, IsString, IsUUID, MaxLength } from 'class-validator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';

export class RecallImpactQueryDto {
  @IsString()
  @IsOptional()
  @MaxLength(100)
  @OptionalStringTransform()
  supplierLot?: string;

  @IsUUID()
  @IsOptional()
  supplierId?: string;

  @IsUUID()
  @IsOptional()
  originLotId?: string;
}
